import { useEffect } from "react";
import useReveal from "@/lib/useReveal";
import Header from "@/components/uma/Header";
import Hero from "@/components/uma/Hero";
import Services from "@/components/uma/Services";
import Solution from "@/components/uma/Solution";
import Problem from "@/components/uma/Problem";
import Benefits from "@/components/uma/Benefits";
import Contact from "@/components/uma/Contact";
import Footer from "@/components/uma/Footer";
import WhatsappFloating from "@/components/uma/WhatsappFloating";

export default function Home() {
    useReveal();

    useEffect(() => {
        document.title =
            "Estela Altez Palarin · Estudio Contable en Rocha, Uruguay";
    }, []);

    return (
        <main data-testid="home-page">
            <Header />
            <Hero />
            <Services />
            <Solution />
            <Problem />
            <Benefits />
            <Contact />
            <Footer />
            <WhatsappFloating />
        </main>
    );
}
